<template lang="pug">
.ant-forest-auth(v-show="!preparing")
  .exchange
    .item
      img(
        alt="hello",
        src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/1EFeAICGQPRDAXhWUk5Kn.png"
      )
      span.content {{ bikeName }}
    .divider
      img(
        alt="exchange",
        src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/3BMITImBwx8bNSUc_lm3o.svg"
      )

    .item
      img(
        alt="ant-forest",
        src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/4gqt0PgpUr6B3n50Hhi91.png"
      )
      span.content {{ antForest }}
  .info.white.line
    .title 开通蚂蚁森林能量需要：
    .info-item · 绑定发放能量的支付宝账号
    .info-item · 将以下信息授权给蚂蚁森林，用于能量计算
    .info-sub-item · 与哈啰账号绑定的支付宝账户信息
    .info-sub-item(v-if="!showNew") · 单车/助力车骑行开始、结束时间
    template(v-else)
      .info-sub-item · 出行开始时间、结束时间、出行里程
      .info-sub-item · 以及未来接入蚂蚁森林的业务需要用于能量计算的数据。
  .hint.white
    .hint-body 提示：确认您已在支付宝开启蚂蚁森林，开通后，用支付宝、花呗购买的骑行卡骑行或用支付宝、花呗支付车费可获得能量
  .open-btn.flex-mid(@click="bind") 立即开通
  Dialog(
    :show="dialog",
    @cancel="dialog = false",
    @ok="bindAlipay",
    title="温馨提示",
    content="开通蚂蚁森林需要关联支付宝账号",
    ok-text="去关联",
    cancel-text="暂不关联",
    ok-primary
  )
</template>

<script>
import { Native } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import Toast from '@/components/toast';
import Loading from '@/components/loading';
import { getTokenAndKey, getTokenAndLocation, isPreRender } from '../../utils/index';
import {
  openForest,
  bindAlipayUser,
  getForestAccountStatus,
} from '../../api/ant-forest';
import Dialog from './components/dialog';

export default {
  components: {
    Dialog,
  },
  data() {
    return {
      account: null,
      code: null,
      ok: false,
      dialog: false,
      showNew: false,
      preparing: true,
    };
  },
  computed: {
    bikeName() {
      return this.showNew ? '哈啰' : '单车、助力车骑行';
    },
    antForest() {
      return '蚂蚁森林能量';
    },
  },
  created() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      // eslint-disable-next-line no-useless-return
      return;
    }
  },
  async mounted() {
    // Loading.show('正在开通');
    UBT.pageView({
      pageId: 'platform_open_ant_forest',
      categoryId: 'platform',
      businessInfo: {
        adsource: this.$route.query.adsource,
      },
    });
    setTimeout(() => {
      if (this.preparing) {
        this.preparing = false;
      }
    }, 1000);
    const { token, cityCode, adCode } = await getTokenAndLocation();

    getForestAccountStatus({
      token,
      pointType: 2,
      cityCode,
      adCode,
    })
      .then((v) => {
        if (v && v.data) {
          const { antGray } = v.data;
          if (antGray) {
            this.showNew = true;
          }
        }
      })
      .catch(() => null)
      .then(() => {
        this.preparing = false;
      });
  },
  methods: {
    bind() {
      UBT.clickButton({
        pageId: 'platform_open_ant_forest',
        buttonName: 'platform_open_now',
        categoryId: 'platform',
        businessInfo: {
          adsource: this.$route.query.adsource,
        },
      });
      this.bindAlipay();
    },
    async bindAlipay() {
      UBT.clickButton({
        pageId: 'platform_open_ant_forest',
        buttonName: 'platform_connect_alipay',
        categoryId: 'platform',
        businessInfo: {},
      });
      const { token } = await this.initUser();
      this.dialog = false;

      Loading.show('正在开通');

      const { code, errorMsg } = await Promise.race([
        Native.callNative({
          method: 'openAlipayAuth',
          classMap: 'business/user',
          params: {},
          timeout: false,
        })
          .then((v) => v || {})
          .catch(() => ({})),
        new Promise((_, reject) => {
          setTimeout(() => {
            reject();
          }, 30000);
        }),
      ]).catch(() => ({}));
      if (!code) {
        Loading.close();
        Toast.show(errorMsg || '授权失败');
        return;
      }
      this.code = code;
      bindAlipayUser({
        token,
        aliPayAuthCode: code,
      })
        .then(({ data }) => {
          if (data && data.loginName) {
            this.ok = true;
            this.account = data.loginName;
            this.openForest();
          } else {
            throw new Error();
          }
        })
        .catch((e) => {
          Loading.close();
          Toast.show(e && e.message ? e.message : '关联支付宝账号失败');
        });
    },
    initUser() {
      return getTokenAndKey().catch(() => ({}));
    },
    async openForest() {
      const { token, cityCode, adCode } = await getTokenAndLocation();
      openForest({ token, cityCode, adCode })
        .then(() => {
          const query = {
            account: this.account,
            success: true,
          };
          if (this.showNew) {
            query.showNew = true;
          }
          this.$router.replace({
            path: '/ant-forest/success',
            query,
          });
        })
        .catch((e) => {
          Toast.show(e && e.message ? e.message : '开通失败');
        })
        .then(() => {
          Loading.close();
        });
    },
    goForest() {
      UBT.clickButton({
        pageId: 'platform_open_ant_forest',
        buttonName: 'platform_check_ant_forest',
        categoryId: 'platform',
        businessInfo: {},
      });
      window.location = 'alipays://platformapi/startapp?appId=60000002&source=hellobikeapp';
    },
  },
};
</script>

<style lang="less" scoped>
.ant-forest-auth {
  background: #f0f3f5;
  font-size: 0.14rem;
  min-height: 100%;

  img {
    pointer-events: none;
  }

  .line {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      height: 0.01rem;
      background: rgba(255, 255, 255, 0);
      box-shadow: 0 0.01rem 0 0 #f0f3f5;
      width: 3.51rem;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .icon {
    margin-right: 0.08rem;
    width: 0.16rem;
    height: 0.16rem;
  }

  .exchange {
    height: 1.32rem;
    background: #fff;
    display: flex;
    justify-content: center;
    padding-top: 0.33rem;

    .divider {
      width: 0.8rem;
      padding-top: 0.18rem;
      display: flex;
      justify-content: center;

      img {
        width: 0.16rem;
        height: 0.16rem;
      }
    }

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        height: 0.52rem;
        width: 0.52rem;
      }

      .content {
        font-size: 0.12rem;
        font-weight: 400;
        color: #333;
        line-height: 0.17rem;
        margin-top: 0.07rem;
      }

      // &::after {
      //   font-size: 0.12rem;
      //   color: #333;
      //   position: absolute;
      //   white-space: nowrap;
      //   top: 0.6rem;
      //   left: 50%;
      //   transform: translateX(-50%);
      // }

      // &:nth-of-type(3) {
      //   &::after {
      //     content: "蚂蚁森林能量";
      //   }
      // }

      // &:nth-of-type(1) {
      //   &::after {
      //     content: "单车、助力车骑行";
      //   }
      // }
    }
  }

  .white {
    background: white;
  }

  .info {
    padding: 0.12rem;

    .title {
      font-size: 0.16rem;
      font-weight: 500;
      color: #242729;
      margin-bottom: 0.12rem;
    }

    .info-item {
      font-size: 0.14rem;
      color: #242729;
      margin-bottom: 0.08rem;
    }

    .info-sub-item {
      font-size: 0.12rem;
      color: #5a6066;
      margin-bottom: 0.04rem;
      padding-left: 0.1rem;
    }
  }

  .alipay {
    padding: 0.13rem 0.12rem 0.13rem;
    display: flex;
    align-items: flex-start;

    span {
      display: inline-block;
      height: 0.2rem;
      font-size: 0.14rem;
      color: #242729;
      line-height: 1;

      &:not(:last-of-type) {
        margin-bottom: 0.04rem;
      }
    }
  }

  .hint {
    padding: 0.12rem 0.12rem;
    display: flex;
    align-items: flex-start;

    .hint-body {
      flex: 1;
      font-size: 0.12rem;
      color: #5a6066;
    }
  }

  .open-btn {
    margin: 0 auto;
    margin-top: 0.12rem;
    width: 3.51rem;
    height: 0.48rem;
    background: #08f;
    border-radius: 0.08rem;
    font-size: 0.18rem;
    font-weight: 500;
    color: #fff;
  }
}
</style>
